// get chat thread
export const GET_CHAT_THREADS = 'GetChatThreads';
export const GET_CHAT_THREADS_SUCCESS = 'GetChatThreadsSuccess';
export const GET_CHAT_THREADS_ERROR = 'GetChatThreadsError';

// delete chat thread
export const DELETE_CHAT_THREAD = 'DeleteChatThread';
export const DELETE_CHAT_THREAD_SUCCESS = 'DeleteChatThreadSuccess';
export const DELETE_CHAT_THREAD_ERROR = 'DeleteChatThreadError';

// update chat thread

export const UPDATE_CHAT_THREADS = 'UPDATE_CHAT_THREADS';
